import { request } from './apiClient'

export const fetchConversations = () =>
  request("GET", "/v1/conversations/")

export const createConversation = (engineId) =>
  request("POST", "/v1/conversations/", { engine_id: engineId })

export const fetchConversation = (id) =>
  request("GET", `/v1/conversations/${id}/`)

export const updateConversation = (id, data) =>
  request("PATCH", `/v1/conversations/${id}/`, data)

export const deleteConversation = (id) =>
  request("DELETE", `/v1/conversations/${id}/`)

export const generateConversationTitle = (id) =>
  request("POST", `/v1/conversations/${id}/generate_title/`)
